export enum CompanyTypes {
  Vendor = 'Service Provider',
  Consumer = 'Operator'
}
